export class LevelGeneratorScrewUp extends Error {
	constructor(message?: string) {
		super(message);
		this.name = "LevelGeneratorScrewUp";
	}
}
